import { render, staticRenderFns } from "./CollapseToggle.vue?vue&type=template&id=27f7b015&scoped=true"
import script from "./CollapseToggle.vue?vue&type=script&lang=js"
export * from "./CollapseToggle.vue?vue&type=script&lang=js"
import style0 from "./CollapseToggle.vue?vue&type=style&index=0&id=27f7b015&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f7b015",
  null
  
)

export default component.exports